import { TpContainerElementDTO } from '../../../../data/dashboard-template/schemas';
import { DASHBOARD_TEMPLATE_ELEMENT_TYPES as ELEMENT_TYPES } from '../../../../data/dashboard-template/constants';
import { jsonReplaceDbActionVariables } from '../helpers/jsonReplaceVariables';
import {
  TpDashboardActionContext,
  TpDbActionStepDefinition as TpDbActionStepTypeDefinition,
  DBACTIONVARTYPES,
} from '../interfaces';
import { createElement } from '../../data/dashboardsSlice';
import { isChartDefinition, TpDashboardCreationContext } from '../../dashboard/interfaces';

function getJsonSchema(): any {
  return {
    type: 'object',
    title: 'Add widget',
    description:
      'Creates a new chart widget on the dashboard. This widget is temporary for the user session and will not be permanently saved.',
    properties: {
      type: { type: 'string', const: 'AddWidget' },
      targetSectionId: {
        type: 'string',
        description: 'Identifier of the section in the dashboard where this widget should be added to.',
      },
      definition: {
        type: 'object',
        description:
          'Definition of the widget to be displayed. See /elements/widgets for more information. Note that this definition can refer to variables created earlier via "$VariableName".',
      },
    },
    required: ['type', 'targetSectionId', 'definition'],
  };
}

function execute(ctx: TpDashboardActionContext, step: any, onCompleted: () => void) {
  const chartDef = jsonReplaceDbActionVariables(ctx, step.definition);

  // Complete definition for the new widget element.
  chartDef.type = ELEMENT_TYPES.Widget;

  // Mock parent sequence definition for layout hint purposes
  const parentSequenceDef: TpContainerElementDTO = {
    type: ELEMENT_TYPES.LayoutSequence,
    elements: [],
  };

  // Flatten context variables from the dashboard action context, only including those of type Value.
  const contextVariables = Object.entries(ctx.variables).reduce(
    (acc: { [key: string]: any }, [variableName, variableContent]) => {
      if (variableContent.type === DBACTIONVARTYPES.Value) {
        acc[variableName] = variableContent.content;
      }
      return acc;
    },
    {},
  );

  const creationContext: TpDashboardCreationContext = {
    dataContext: ctx.dataContext,
    contextVariables,
  };

  const dashboardElement = createElement(creationContext, parentSequenceDef, chartDef, {}, {});

  if (isChartDefinition(dashboardElement)) {
    ctx.dashboardContext.addChart(dashboardElement, ctx.dashboardContext.dashboardDefId, step.targetSectionId);
  } else {
    console.warn('The created dashboard element is not a chart definition:', dashboardElement);
  }

  onCompleted();
}

const dbActionStepTypeAddWidget: TpDbActionStepTypeDefinition = {
  stepType: 'AddWidget',
  execute,
  getJsonSchema,
};

export default dbActionStepTypeAddWidget;
